import React from 'react';
import AlertModal from './AlertModal';

const PROMPT_OVERLAY = {
  presentation: 'prompt',
  overlayOpacity: 0.16,
  overlayColor: '15, 23, 42',
  overlayBlur: 2,
};

/**
 * Error feedback — compact slide-up sheet (matches profile / AlertModal prompt style).
 */
const ErrorModal = ({
  isOpen,
  onClose,
  title = 'Error',
  message,
  details,
  retryAction,
  style = {},
  zIndex = 1000,
}) => {
  const actions = retryAction
    ? [
        { label: 'Close', onClick: onClose, variant: 'secondary' },
        { label: 'Retry', onClick: retryAction, variant: 'primary' },
      ]
    : [{ label: 'Close', onClick: onClose, variant: 'primary' }];

  return (
    <AlertModal
      isOpen={isOpen}
      onClose={onClose}
      variant="error"
      subject={title}
      body={message}
      details={details}
      style={style}
      zIndex={zIndex}
      allowOverlayClose
      actions={actions}
      {...PROMPT_OVERLAY}
    />
  );
};

export default ErrorModal;
